export default __webpack_public_path__ + "static/picClub-80ca853c8cbd645ebee7b8b36eade7b7.jpg";